import { WrapupPrompt } from '../models/wrap-up-prompt.enum';

export const wrapupRequiredValues = new Set<WrapupPrompt>([
  WrapupPrompt.Mandatory,
  WrapupPrompt.Timeout,
  WrapupPrompt.ForcedTimeout
]);
